const primary = "#2E7D32";
const primaryLight = "rgb(69 186 65)";
const primaryDark = "rgb(46, 128, 44)";
const secondary = "rgba(52, 60, 62, 1)";
const white = "#fff";
const errorLight = "#AE1913";
const errorDark = "#ea7371";
const black80 = "#000000cc";

export {
  primary,
  primaryLight,
  primaryDark,
  secondary,
  white,
  errorLight,
  errorDark,
  black80,
};
